import React from "react";

import "./EflowLoginFooter.css";

export const EflowLoginFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="EflowLoginFooter">
      <div className="EflowLoginFooter__information">
        <div className="EflowLoginFooter__logo">eflow Single Sign-On · </div>
        <div className="EflowLoginFooter__copyright">
          &nbsp;&copy; {currentYear} eflow a/s
        </div>
      </div>
      <div className="EflowLoginFooter__privacy">
        <a href="https://www.eflowsoftware.com/about-us/eula">
          End User License Agreement
        </a>
        <p>&nbsp;·&nbsp;</p>
        <a href="https://www.eflowsoftware.com/about-us/data-processing-agreement">
          Data Processing Agreement
        </a>
      </div>
    </div>
  );
};
